// Do not sort CSS files.

import 'ol/ol.css'
import 'css/index.css'
import 'css/add-feature.css'
import 'css/fragments.css'
import 'css/go.css'
import 'css/login.css'
import 'css/main.css'
import 'css/measure.css'
import 'css/print.css'
import 'css/widget.css'
import 'css/auth.css'
import 'material-design-lite'
import 'global.d' // This is where global variables get declared

import React, { Suspense, lazy } from 'react'

import { CssBaseline, ThemeProvider } from '@mui/material'
import { QueryClientProvider } from '@tanstack/react-query'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { reduxStore } from 'reduxStore'

import { configureApiClient } from 'api/internal/configureApiClient'
import { worker } from 'api/internal/mocks/browser'
import { queryClient } from 'api/internal/queryClient'
import ErrorBoundary from 'app/ErrorBoundary'
import { doMsal } from 'config/msalUtils'
import { poziTheme } from 'theme/theme'

// Prevent initialisation multiple times in development (HMR)
let initialised = false

if (!initialised) {
  const appInfo = window.getAppInfo()
  configureApiClient()

  if (appInfo.environment === 'development') {
    console.log('[MSW] Starting MSW worker...')
    await worker.start({
      serviceWorker: {
        url: '/mockServiceWorker.js'
      },
      // Only intercept requests to our specific API endpoints
      onUnhandledRequest: 'bypass'
    })
    console.log('[MSW] Worker started successfully')
  }

  const AppWrapper = lazy(() => import('app/AppWrapper'))
  const WidgetWrapper = lazy(() => import('widget/WidgetWrapper'))

  // Initialise Microsoft Azure Libraryt (MSAL)
  await doMsal()

  // Make the redux store globally available
  // TODO: remove this one day
  window.store = reduxStore

  // We'll load either the App or Widget here
  const isWidget = appInfo.mode === 'widget'

  const Wrapper = isWidget ? WidgetWrapper : AppWrapper
  const renderElementId = isWidget ? 'widget-search-box' : 'root'

  const renderElement = document.getElementById(renderElementId) as HTMLElement

  const indexComponent = (
    <Provider store={reduxStore}>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<span />}>
          <ThemeProvider theme={poziTheme}>
            <CssBaseline />
            <ErrorBoundary>
              <Wrapper />
            </ErrorBoundary>
          </ThemeProvider>
        </Suspense>
      </QueryClientProvider>
    </Provider>
  )

  const root = createRoot(renderElement)
  root.render(indexComponent)

  initialised = true
} else {
  console.log('index - Already initialised')
}
